import {
    CATALOGUE_CONTENT_TYPE_BY_EXTENSION,
    CATALOGUE_DEFAULT_CONTENT_TYPE,
} from '../constants/catalogue';
import { cleanUrl } from 'src/utils/cleanUrl';

export const getDocumentationMediaUrl = (file: string) => cleanUrl(file);

export const getDocumentationContentType = (file?: string) => {
    if (!file?.trim()) return CATALOGUE_DEFAULT_CONTENT_TYPE;

    const extension = file.split('.').pop()?.toLowerCase();

    return extension
        ? CATALOGUE_CONTENT_TYPE_BY_EXTENSION[extension] ||
              CATALOGUE_DEFAULT_CONTENT_TYPE
        : CATALOGUE_DEFAULT_CONTENT_TYPE;
};
